import maximizeIconTeal from "@assets/images/maximize-icon-teal.svg";
import maximizeIcon from "@assets/images/maximize-icon.svg";
import minimizeIconTeal from "@assets/images/minimize-icon-teal.svg";
import minimizeIcon from "@assets/images/minimize-icon.svg";
import { Button } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import useAppState from "@saleor/hooks/useAppState";
import { makeStyles } from "@saleor/macaw-ui";
import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";

interface StyleProps {
  fullScreen?: boolean;
}

interface FullScreenButton {
  customClass?: string;
}

const useStyles = makeStyles<StyleProps>(
  theme => ({
    icon: {
      width: 24,
      height: 24,
      background: props =>
        props.fullScreen ? `url(${minimizeIcon})` : `url(${maximizeIcon})`
    },
    root: {
      color: "black",
      border: "none",
      borderRadius: "4px",
      outline: "none",
      padding: "0.4rem 0.8rem",
      "& .MuiButton-label": {
        alignItems: "center",
        "& .MuiButton-endIcon": {
          margin: 0,
          marginLeft: "0.8rem"
        }
      },
      "&:hover": {
        color: theme.palette.info.dark,
        "& $icon": {
          background: props =>
            props.fullScreen
              ? `url(${minimizeIconTeal})`
              : `url(${maximizeIconTeal})`
        }
      },
      "&:active": {
        background: "none",
        outline: "3px solid rgba(1, 178, 237, 0.24)"
      }
    }
  }),
  { name: "FullScreenButton" }
);

const FullScreenButton: React.FC<FullScreenButton> = ({ customClass }) => {
  const [appState, dispatchAppState] = useAppState();
  const [fullScreen, setFullScreen] = useState(appState.fullScreen);
  const intl = useIntl();
  const classes = useStyles({ fullScreen });

  useEffect(() => {
    dispatchAppState({
      payload: {
        value: fullScreen
      },
      type: "setFullScreen"
    });
  }, [fullScreen]);

  const toggleFullScreen = () => {
    setFullScreen(current => !current);
  };

  return (
    <Button
      className={classNames(classes.root, customClass)}
      disableElevation
      disableFocusRipple
      disableRipple
      onClick={toggleFullScreen}
      endIcon={<span className={classes.icon}></span>}
      name="full-screen-button"
      id="full-screen-button"
      data-testid="full-screen-button"
    >
      <MyTypography component="span" variant="caption" color="inherit">
        {fullScreen
          ? intl.formatMessage({ defaultMessage: "Minimize" })
          : intl.formatMessage({ defaultMessage: "Full Screen" })}
      </MyTypography>
    </Button>
  );
};

export default FullScreenButton;
